import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { LuTrash2 } from 'react-icons/lu'
import ConfirmModal from '../../components/ConfirmModal/ConfirmModal'
import Dropdown from '../../components/Dropdown/Dropdown'
import { getContactGroupAffiliates } from '../../features/contactGroups/contactGroups'

// WS #2303654: an agent who still holds files is deleted only together with a new owner for them.
// The choices are the active agents of every office the agent works in, each once, without the agent
// itself; the server accepts exactly that set.
const ReassignFilesModal = ({ affiliate, message, onCancel, onConfirm }) => {
  const dispatch = useDispatch()
  const [options, setOptions] = useState([])
  const [loaded, setLoaded] = useState(false)
  const [newOwner, setNewOwner] = useState('')

  useEffect(() => {
    if (!affiliate) return undefined
    let current = true
    setNewOwner('')
    setLoaded(false)

    const officeIds = (affiliate.contactGroups || []).map(group => group?._id || group).filter(Boolean)
    Promise.all(officeIds.map(officeId => dispatch(getContactGroupAffiliates(officeId)))).then(responses => {
      if (!current) return
      const seen = new Set([String(affiliate._id)])
      const merged = []
      responses.forEach(response => {
        const agents = Array.isArray(response?.payload?.data) ? response.payload.data : []
        agents.forEach(agent => {
          if (seen.has(String(agent.value))) return
          seen.add(String(agent.value))
          merged.push(agent)
        })
      })
      setOptions(merged)
      setLoaded(true)
    })

    return () => { current = false }
  }, [affiliate, dispatch])

  return (
    <ConfirmModal
      open={Boolean(affiliate)}
      leftTopIcon={<LuTrash2 size={18} className="text-text-secondary" />}
      title="Choose who takes over the files"
      modalButtonTitle="Delete"
      disabled={!newOwner}
      setOpen={() => {}}
      onClose={onCancel}
      functionButton={() => onConfirm(newOwner)}
    >
      <div className="flex flex-col gap-4" data-testid="reassign-files-modal">
        <p className="text-sm">{message}</p>
        <Dropdown
          label="New owner"
          ariaLabel="New owner"
          value={newOwner}
          setValue={setNewOwner}
          menuItems={options}
          menuFitsField
        />
        {loaded && options.length === 0 && (
          <p className="text-sm">No other active agent works in this office. Add one before deleting this agent.</p>
        )}
      </div>
    </ConfirmModal>
  )
}

export default ReassignFilesModal
